import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/server/information';

export const SERVER_VALIDATE_SALESFORCE_CASEID_GET_SUCCESS =
  `${rootActionPath}/VALIDATE_SALESFORCE_CASEID_${SUCCESS_SUFFIX}`;
export const SERVER_VALIDATE_SALESFORCE_CASEID_GET_FAILURE =
  `${rootActionPath}/VALIDATE_SALESFORCE_CASEID_${FAILURE_SUFFIX}`;
